import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n, useSession } from '@newtontechnologies/applib-frontend';
import { Modal, Form, Radio } from 'antd';
import './style.less';
import download from '../../download';
const SUB_FORMAT = {
    srt: 'exportSrt50',
    srt_gov: 'exportSrt35',
    vtt: 'exportVtt50',
    vtt_gov: 'exportVtt35',
};
const SubtitleModal = ({ task, visible, onCancel, onOk, }) => {
    const { connection } = useSession();
    const { intl } = useI18n();
    const [form] = Form.useForm();
    const handleDownloadSubtitles = () => {
        const selectedFormat = form.getFieldValue('subtformat');
        void download(task.projectName, task.id, connection, selectedFormat);
        onOk();
    };
    return (_jsx(Modal, { className: "subtitle-format-modal", open: visible, cancelText: intl.formatMessage({ id: 'cancel' }), onCancel: onCancel, okText: intl.formatMessage({ id: 'downloadSubtitles' }), onOk: handleDownloadSubtitles, destroyOnClose: true, forceRender: true, children: _jsx(Form, { form: form, initialValues: {
                subtformat: 'srt',
            }, children: _jsx(Form.Item, { name: "subtformat", label: intl.formatMessage({ id: 'chooseSubtitleFormat' }), children: _jsx(Radio.Group, { name: "radiogroup", children: Object.entries(SUB_FORMAT).map(([key, value]) => (_jsx(Radio, { value: key, children: intl.formatMessage({ id: value }) }, key))) }) }) }) }));
};
export default SubtitleModal;
